import React,{Component} from 'react';
import {Container} from '../styles/style.js'
import Select from 'react-select'
import moment from 'moment'
import Cookies from 'js-cookie';

export default class DatePicker extends Component{
    constructor(props){
        super(props);
        this.state = {
            month:'',
            day:'',
            year:'',
        }

        var backGround = '#292929';
        var textColor = 'white'
        if(Cookies.get('theme') === 'light'){
            textColor = 'black';
            backGround = '#bababa';
        }

        this.customStyles = {
            option: (provided, state) => ({
                ...provided,
                color: textColor,
                padding: 20,
                background:backGround,
                borderBottom: '1px dotted black'
            }),
            singleValue:(provided,state) => ({
                ...provided,
                color:textColor,
                opacity: state.isDisabled ? .3 : 1,
              }),
            menuList: base => ({
                ...base,
                padding: 0,
            }),
            control: (base, state) => ({
                ...base,
                background: "none",
                // match with the menu
                borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
                // Overwrites the different states of border
                borderColor: state.isFocused ? "#007575" : "#696969",
                // Removes weird border around container
                boxShadow: state.isFocused ? null : null,
                marginRight:'.5em',
                marginBottom:'1em',
                fontSize:'1em',
                opacity: state.isDisabled ? .3 : 1,
            }),
            noOptionsMessage:(base,state) =>({
                ...base,
                color:textColor,
                background:backGround
            }),
            input:(base,state)=>({
                ...base,
                color:textColor,
                opacity: '1'
            })
        }
    }
    

    getMonthOptions(){
        var options = [];
        for(let i = 1;i <= 12;i++){
            options.push(
                {value:i,label:i}
            )
        }

        return options;
    }

    handleChange = type => option =>{
        this.setState({[type]:option.value},()=>{
            if(this.state.month !== '' && this.state.day !== '' && this.state.year !== ''){
                this.props.onDateDone(this.state.month + '/' + this.state.day + '/' + this.state.year)
            }
        })
    }

    getDayOptions(){
        var options = [];

        var numberOfDaysInMonth = moment(this.state.month, "MM").daysInMonth()
        for(let i = 1;i <= numberOfDaysInMonth;i++){
            options.push(
                {value:i,label:i}
            )
        }
        return options;
    }

    getYearOptions(){
        var options = [];
        var startYear = 2022;
        var endYear = 1920;
        for(let i = startYear;i >= endYear;i--){
            options.push(
                {value:i,label:i}
            )
        }
        return options;
    }

    render(){
        return(
            <Container>
                <Select
                    id='month' 
                    styles={this.customStyles} 
                    options={this.getMonthOptions()}
                    defaultValue={{ label: "Month", value: 'Month' }}
                    onChange={this.handleChange('month')}>
                </Select>

                <Select 
                    id='day'
                    styles={this.customStyles} 
                    options={this.getDayOptions()}
                    defaultValue={{ label: "Day", value: 'Day' }}
                    isDisabled={this.state.month === ''}
                    onChange={this.handleChange('day')}>
                </Select>

                <Select 
                    id='year'
                    styles={this.customStyles} 
                    options={this.getYearOptions()}
                    defaultValue={{ label: "Year", value: 'Year' }}
                    isDisabled={this.state.day === ''}
                    onChange={this.handleChange('year')}>
                </Select>
            </Container>
        )
    }
}